import React, { useState, useEffect } from "react";
import Topbar from "./topBar";
import Sidebar from "./sideBar";
import { Link } from "react-router-dom";
import Cookies from "universal-cookie";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Swal, { SweetAlert } from "sweetalert2/dist/sweetalert2.js";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { Tooltip } from "react-tooltip";
import { EDIT, ORG_CUSTOMER } from "../../constants/url";
import { FiEye } from "react-icons/fi";
import { toast, Bounce } from "react-toastify";
import { TabPanel, TabContext, TabList } from "@mui/lab";
import { privateApiCall } from "../../api/privateApi";
import ShareIcon from "@mui/icons-material/Share";
import {
  Table,
  MenuItem,
  Select,
  Typography,
  Badge,
  FormControlLabel,
  Checkbox,
  Button,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Modal,
  Grid,
  TextField,
  Fade,
  InputLabel,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
const cookies = new Cookies();
const Subscription = () => {
  const [value, setValue] = useState("1");
  const [subscription, setSubscription] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [isPrimaryEmail, setIsPrimaryEmail] = useState(false);
  const [showPrimaryConfirmation, setShowPrimaryConfirmation] = useState(false);
  const [showAddPrimaryConfirmation, setShowAddPrimaryConfirmation] =
    useState(false);
  const [data, setData] = useState({
    recipientEmail: "",
    recipientName: "",
    designation: "",
  });
  const [newaddress, setNewaddress] = useState({
    Address: "",
    area: "",
    locality: "",
    landmark: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
  });
  const [opens, setOpens] = useState(false);
  const [selectedCode, setSelectedCode] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [customers, setCustomers] = useState([]);
  const handleOpen = (code) => {
    setSelectedCode(code);
    setOpens(true);
  };
  const handleCloses = () => {
    setOpens(false);
    setSelectedCode("");
    setSelectedUser("");
  };
  const handleAssign = async () => {
    const requestUrl = "/api/organisation/assignVoucherCode";
    const payload = {
      userId: selectedUser,
      subscription_id: selectedVoucherData.subscription_id,
    };
    const response = await privateApiCall(requestUrl, "POST", payload);
    toast.success(response.data.msg, {
      position: "top-right",
      transition: Bounce,
    });
    
   
    handleCloses();
  };
  const customerData = async () => {
    const requestUrl = `${ORG_CUSTOMER}`;
    const response = await privateApiCall(requestUrl, "GET");
    setCustomers(response.data);
  };
  const [recipientId, setRecipientId] = useState(null);
  const [orgEmail, setOrgEmail] = useState(null);
  const [orgAddress, setOrgAddress] = useState({
    Address: "",
    locality: "",
    area: "",
    city: "",
    country: "",
    state: "",
    pincode: "",
    landmark: "",
  });
  const [primaryEmail, setPrimaryEmail] = useState("");
  const [recipients, setRecipients] = useState([]);
  const [address, setAddress] = useState([]);
  const [isPrimaryAddress, setIsPrimaryAddress] = useState(false);
  const [primaryAddress, setPrimaryAddress] = useState("");
  const [addressId, setAddressId] = useState(null);
  const handleShowModal = () => setShowModal(true);
  const handleShowModalAdd = () => setShowModalAdd(true);
  const handleCloseModal = () => {
    setShowModal(false);
    setData({
      recipientEmail: "",
      recipientName: "",
      designation: "",
    });
    setRecipientId(null);
  };
  const handleCloseModalAdd = () => {
    setShowModalAdd(false);
    setNewaddress({
      Address: "",
      area: "",
      locality: "",
      landmark: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
    });
    setAddressId(null);
  };
  const handleDownload = (transactionId) => {
    const fakeDownloadLink = `https://example.com/download/billing/${transactionId}`;
    // Create a dummy anchor element to trigger the download
    const anchor = document.createElement("a");
    anchor.href = fakeDownloadLink;
    anchor.download = `billing_${transactionId}.pdf`;
    anchor.click();
  };
  const handleTabChange = (e, newValue) => {
    setValue(newValue);
    setShowPromotionalCredits(false);
    setShowBalancedCredits(false);
    setShowUsedCredits(false);
    setSelectedVoucher("");
  };

  const fetchSubscription = async () => {
    try {
      const requestUrl = `/api/organisation/getSubscription`;
      const response = await privateApiCall(requestUrl, "GET");
      setSubscription(response.data.data);
    } catch (error) {
      console.error("Error fetching subscription:", error);
    }
  };
  const [voucher, setVoucher] = useState("");
  const [voucherCount, setVocherCount] = useState("");
  const [showPromotionalCredits, setShowPromotionalCredits] = useState(false);
  const [showBalancedCredits, setShowBalancedCredits] = useState(false);
  const [showUsedCredits, setShowUsedCredits] = useState(false);
  const fetchVoucher = async () => {
    const requestUrl = "/api/organisation/getMyVocher";
    const response = await privateApiCall(requestUrl, "GET");
    setVoucher(response.data.vouchers);
    const count = response.data.vouchers.length;
    setVocherCount(count);
  };
  const [selectedVoucher, setSelectedVoucher] = useState("");
  const handleVoucherChange = (event) => {
    setSelectedVoucher(event.target.value);
  };
  const selectedVoucherData = voucher.length
    ? voucher.find((v) => v.vocher_id === selectedVoucher)
    : null;
    console.log(selectedVoucherData,"voucher code data")
  const handlePromotionalCredits = async () => {
    setShowBalancedCredits(false);
    setShowUsedCredits(false);
    setShowPromotionalCredits(true);
    setSelectedVoucher("");
  };

  const handleBalancedCredits = () => {
    setShowPromotionalCredits(false);
    setShowUsedCredits(false);
    setShowBalancedCredits(true);
  };
  const handleUsedCredits = () => {
    setShowPromotionalCredits(false);
    setShowBalancedCredits(false);
    setShowUsedCredits(true);
  };
  const isVoucherActive = (fromDate, endDate) => {
    const currentDate = new Date().toISOString().slice(0, 10);
    return currentDate >= fromDate && currentDate <= endDate;
  };

  const get_Profile = async () => {
    try {
      const requestUrl = `/api/organisation/get_profile/${cookies.get(
        "org_id"
      )}?token=${cookies.get("org_token")}`;
      const response = await privateApiCall(requestUrl, "GET");
      return response.data.admin[0];
    } catch (error) {}
  };

  useEffect(() => {
    fetchSubscription();
    fetchData();
    fetchVoucher();
    customerData();
    
  }, []);
  const fetchData = async () => {
    const orgAdminData = await get_Profile();
    setOrgEmail(orgAdminData.email);
    const currentAddress = {
      Address: orgAdminData.Address,
      locality: orgAdminData.locality,
      area: orgAdminData.area,
      city: orgAdminData.city,
      state: orgAdminData.state,
      country: orgAdminData.country,
      pincode: orgAdminData.pincode,
      landmark: orgAdminData.landmark,
    };

    setOrgAddress(currentAddress);
    const recipiente = orgAdminData.recipients;
    const addres = orgAdminData.address;
    // console.log(addres, "inside the fetchData...");
    const hasPrimaryRecipient = recipiente.some(
      (recipient) => recipient.isPrimary
    );
    setRecipients([
      {
        recipientEmail: orgAdminData.email,
        recipientName: "",
        designation: "",
        isPrimary: hasPrimaryRecipient ? false : true,
      },
      ...recipiente,
    ]);
    const hasPrimaryAddress = addres.some(
      (recipient) => recipient.isPrimaryAddress
    );
    setAddress([
      {
        Address: orgAdminData.Address,
        area: orgAdminData.area,
        locality: orgAdminData.locality,
        landmark: orgAdminData.landmark,
        city: orgAdminData.city,
        state: orgAdminData.state,
        country: orgAdminData.country,
        pincode: orgAdminData.pincode,
        isPrimaryAddress: hasPrimaryAddress ? false : true,
      },
      ...addres,
    ]);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const requestUrl = "/api/organisation/addRecipient";
      const payload = {
        ...data,
        isPrimaryEmail: isPrimaryEmail,
      };
      const response = await privateApiCall(requestUrl, "POST", payload);
      handleCloseModal();
      fetchData();

      if (isPrimaryEmail) {
        const updatedRecipients = recipients.map((recipient) => {
          if (recipient.recipientEmail === data.recipientEmail) {
            return { ...recipient, isPrimary: true };
          }
          return { ...recipient };
        });
        setPrimaryEmail(data.recipientEmail);
        setRecipients(updatedRecipients);
        toast.info(response.data.message, {
          position: "top-right",
          transition: Bounce,
        });
      } else {
        toast.info(response.data.message, {
          position: "top-right",
          transition: Bounce,
        });
        fetchData();
      }
    } catch (error) {
      console.error("Error adding recipient:", error);
    }
  };

  const handleUpdate = async (event) => {
    event.preventDefault();

    try {
      const requestUrl = `/api/organisation/updateRecipient/${recipientId}`;
      const payload = {
        recipientEmail: data.recipientEmail,
        recipientName: data.recipientName,
        designation: data.designation,
        isPrimary: isPrimaryEmail,
      };
      const response = await privateApiCall(requestUrl, "PUT", payload);

      handleCloseModal();
      fetchData();
      toast.info(response.data.message, {
        position: "top-right",
        transition: Bounce,
      });

      if (isPrimaryEmail) {
        const updatedRecipients = recipients.map((recipient) =>
          recipient._id === recipientId
            ? { ...recipient, isPrimary: true }
            : recipient
        );
        setRecipients(updatedRecipients);
      }
    } catch (error) {
      console.error("Error updating recipient:", error);
    }
  };

  const handleCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setIsPrimaryEmail(isChecked);
    if (isChecked) {
      setShowPrimaryConfirmation(true);
    }
  };

  const handlePrimaryConfirmationClose = (confirm) => {
    setShowPrimaryConfirmation(false);
    if (confirm) {
      setPrimaryEmail(data.recipientEmail);
      // If the new email is set as primary, remove the primary badge from the previous primary email
      const updatedRecipients = recipients.map((recipient) => {
        if (recipient.recipientEmail === data.recipientEmail) {
          return { ...recipient, isPrimary: false };
        }

        return { ...recipient, isPrimary: false };
      });

      setRecipients(updatedRecipients);
    } else {
      setIsPrimaryEmail(false); // Uncheck the checkbox if the user cancels the confirmation
    }
  };

  const Action = ({ row }) => {
    const isPrimaryOrLoginEmail =
      row.isPrimary || (orgEmail && row.recipientEmail === orgEmail);
    const handleEditShow = (e) => {
      setRecipientId(row._id);
      setShowModal(true);
      setData({
        recipientEmail: row.recipientEmail,
        recipientName: row.recipientName,
        designation: row.designation,
      });
      setIsPrimaryEmail(row.isPrimary);
    };

    const handleDelete = async () => {
      try {
        const result = await Swal.fire({
          title: `Do You Want to delete ${row.recipientEmail}?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: " #3085d6",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No",
        });
        if (result.isConfirmed) {
          const requestUrl = `/api/organisation/del/${row._id}`;
          const response = await privateApiCall(requestUrl, "DELETE", {});
          fetchData();
          toast.error(response.data.message, {
            position: "top-right",
            transition: Bounce,
          });
        }
      } catch (error) {
        console.error("Error deleting recipient:", error);
      }
    };

    return (
      <span>
        {!isPrimaryOrLoginEmail && (
          <>
            <i
              data-tooltip-id="1"
              data-tooltip-content="Edit"
              onClick={handleEditShow}
            >
              <FiEdit2 size="18px" color="#00C5B2" />
            </i>
            <Tooltip id="1" style={{ fontStyle: "normal" }} />
            <i onClick={handleDelete}>
              <FiTrash2
                size="18px"
                color="red"
                data-tooltip-id="3"
                data-tooltip-content="Delete"
                style={{ marginLeft: "10px", cursor: "pointer" }}
              />
              <Tooltip id="3" style={{ fontStyle: "normal" }} />
            </i>
          </>
        )}
        {isPrimaryOrLoginEmail && (
          <Typography color="gray" variant="body2">
            <FiEdit2
              size="18px"
              color="#00C5B2"
              data-tooltip-id="2"
              data-tooltip-content="Disabled"
              style={{ cursor: "not-allowed" }}
            />
            <FiTrash2
              size="18px"
              color="red"
              data-tooltip-id="2"
              data-tooltip-content="Disabled"
              style={{ marginLeft: "10px", cursor: "not-allowed" }}
            />
            <Tooltip id="2" style={{ fontStyle: "normal" }} />
          </Typography>
        )}
      </span>
    );
  };

  const invoice = {
    invoiceNo: "#VL25000351",
    date: "27 Mar, 2021 9:58 PM",
    paymentStatus: "Paid",
    totalAmount: "$755.96",
    billingAddress: {
      name: "David Nichols",
      address: "305 S San Gabriel Blvd",
      phone: "(123) 456-7890",
    },
    shippingAddress: {
      name: "David Nichols",
      address: "305 S San Gabriel Blvd",
      phone: "(123) 456-7890",
    },
    legalRegistrationNo: "987654",
    email: "velzon@themesbrand.com",
    website: "www.themesbrand.com",
    contactNo: "0123456789",
  };

  const handleSubmitAddress = async (event) => {
    event.preventDefault();
    try {
      const requestUrl = "/api/organisation/addNewAddress";
      const payload = {
        ...newaddress,
        isPrimaryAddress: isPrimaryAddress,
      };

      const response = await privateApiCall(requestUrl, "POST", payload);
      handleCloseModalAdd();
      fetchData();
      if (isPrimaryAddress) {
        const updatedAddresses = address.map((add) =>
          add.isPrimaryAddress ? { ...add, isPrimaryAddress: false } : add
        );

        setPrimaryAddress(newaddress);
        setAddress(updatedAddresses);
      } else {
        fetchData();
      }
    } catch (error) {}
  };
  const handleUpdateAddress = async (event) => {
    event.preventDefault();
    try {
      const requestUrl = `/api/organisation/updateAddress/${addressId}`;
      const payload = {
        ...newaddress,
        isPrimaryAddress: isPrimaryAddress,
      };

      const response = await privateApiCall(requestUrl, "PUT", payload);
      handleCloseModalAdd();
      fetchData();
      if (isPrimaryAddress) {
        const updatedAddress = address.map((addr) =>
          addr._id === addressId
            ? { ...address, isPrimaryAddress: true }
            : address
        );
        setAddress(updatedAddress);
      }
    } catch (error) {}
  };

  const handleChangeAddress = (e) => {
    const { name, value } = e.target;
    setNewaddress((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleAddCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setIsPrimaryAddress(isChecked);
    if (isChecked) {
      setShowAddPrimaryConfirmation(true);
    }
  };

  const handleAddPrimaryConfirmation = (confirm) => {
    setShowAddPrimaryConfirmation(false);
    if (confirm) {
      setPrimaryAddress(newaddress);
    }
  };

  const sortedAddresses = address.sort(
    (a, b) => b.isPrimaryAddress - a.isPrimaryAddress
  );
  const sortedRecipients = recipients.sort((a, b) => (b.isPrimary ? 1 : -1));
  const AddressAction = ({ row }) => {
    const fieldsMatch = (address1, address2) => {
      return (
        address1.Address === address2.Address &&
        address1.area === address2.area &&
        address1.locality === address2.locality &&
        address1.landmark === address2.landmark &&
        address1.city === address2.city &&
        address1.state === address2.state &&
        address1.country === address2.country &&
        address1.pincode === address2.pincode
      );
    };
    const disableAddress =
      row.isPrimaryAddress || (orgAddress && fieldsMatch(row, orgAddress));
    const handleEditAdd = (e) => {
      try {
        setAddressId(row._id);
        setShowModalAdd(true);
        setNewaddress({
          Address: row.Address,
          area: row.area,
          locality: row.locality,
          landmark: row.landmark,
          city: row.city,
          state: row.state,
          country: row.country,
          pincode: row.pincode,
        });
        setIsPrimaryAddress(row.isPrimaryAddress);
      } catch (error) {
        console.error(error);
      }
    };
    const handleDeleteAdd = async () => {
      try {
        const result = await Swal.fire({
          title: "Do You Want to delete this Billing Address?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: " #3085d6",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No",
        });
        if (result.isConfirmed) {
          const requestUrl = `/api/organisation/delAddress/${row._id}`;
          const response = await privateApiCall(requestUrl, "DELETE", {});
          fetchData();
        }
      } catch (error) {
        console.error(error);
      }
    };
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        {!disableAddress && (
          <>
            <i
              data-tooltip-id="1"
              data-tooltip-content="Edit"
              onClick={handleEditAdd}
              style={{ marginRight: "10px", cursor: "pointer" }}
            >
              <FiEdit2 size="18px" color="#00C5B2" />
            </i>
            <Tooltip id="1" style={{ fontStyle: "normal" }} />
            <i
              data-tooltip-id="3"
              data-tooltip-content="Delete"
              onClick={handleDeleteAdd}
              style={{ cursor: "pointer" }}
            >
              <FiTrash2 size="18px" color="#FF0000" />
              <Tooltip id="3" style={{ fontStyle: "normal" }} />
            </i>
          </>
        )}
        {disableAddress && (
          <Typography
            color="gray"
            variant="body2"
            style={{ display: "flex", alignItems: "center" }}
          >
            <FiEdit2
              size="18px"
              color="#00C5B2"
              data-tooltip-id="2"
              data-tooltip-content="Disabled"
              style={{ cursor: "not-allowed", marginRight: "10px" }}
            />
            <FiTrash2
              size="18px"
              color="red"
              data-tooltip-id="2"
              data-tooltip-content="Disabled"
              style={{ cursor: "not-allowed" }}
            />
            <Tooltip id="2" style={{ fontStyle: "normal" }} />
          </Typography>
        )}
      </div>
    );
  };

  // console.log(showPromotionalCredits, "8888");
  const [open, setOpen] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const transactions = [
    { id: 1, details: "Transaction 1", date: "01-06-2024", value: "₹100" },
    { id: 2, details: "Transaction 2", date: "01-06-2024", value: "₹200" },
    { id: 3, details: "Transaction 3", date: "01-06-2024", value: "₹300" },
    { id: 4, details: "Transaction 4", date: "01-06-2024", value: "₹400" },
    { id: 5, details: "Transaction 5", date: "01-06-2024", value: "₹500" },
  ];

  const handleClose = () => {
    setOpen(false);
    setSelectedInvoice(null);
  };

  return (
    <div id="wrapper">
      <Topbar backgroundColor="#0baae5" />
      <Sidebar />
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box">
                  <h4 className="page-title float-left">Subscription</h4>
                  <ol className="breadcrumb float-right">
                    <li className="breadcrumb-item">
                      <Link to="/organisation/dashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">Subscription</li>
                  </ol>
                  <div className="clearfix"></div>
                </div>
              </div>
            </div>

            <form>
              <div className="row">
                <div className="col-12">
                  <div className="card-box">
                    <div className="row">
                      <div className="col-12">
                        <div className="p-20 container-fluid">
                          <Box sx={{ width: "100%", typography: "body1" }}>
                            <TabContext value={value}>
                              <Box
                                sx={{ borderBottom: 1, borderColor: "divider" }}
                              >
                                <TabList
                                  onChange={handleTabChange}
                                  aria-label="lab API tabs example"
                                >
                                  <Tab label="Current Subscription" value="1" />
                                  <Tab label="Credit Info" value="2" />
                                  <Tab
                                    label="Billing Address & Other Info"
                                    value="3"
                                  />

                                  <Tab label="Invoices" value="4" />
                                  <Tab label="Email Recipients" value="5" />
                                  <Tab label="Payment Method" value="6" />
                                </TabList>
                              </Box>
                              <TabPanel value="1">
                                {subscription ? (
                                  <Paper
                                    style={{
                                      padding: "16px",
                                      marginBottom: "16px",
                                      display: "inline-block",
                                      width: "300px",
                                      border: "1px solid #ddd",
                                      borderRadius: "8px",
                                      boxShadow:
                                        "0px 0px 10px rgba(0, 0, 0, 0.1)",
                                    }}
                                  >
                                    <Typography
                                      variant="h6"
                                      align="center"
                                      style={{ marginBottom: "8px" }}
                                    >
                                      {subscription.name}
                                    </Typography>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                      }}
                                    >
                                      <span
                                        style={{
                                          textDecoration: "line-through",
                                          marginBottom: "4px",
                                        }}
                                      >
                                        ₹4999
                                      </span>
                                      <span
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: "30px",
                                        }}
                                      >
                                        ₹999
                                      </span>
                                    </div>
                                    <Typography
                                      variant="body1"
                                      align="center"
                                      style={{ marginBottom: "8px" }}
                                    >
                                      Validity: {subscription.validity} days
                                    </Typography>
                                    <Typography
                                      variant="body1"
                                      align="center"
                                      style={{ marginBottom: "8px" }}
                                    >
                                      {/* Coins: {subscription.coins} */}
                                      Coins:100
                                    </Typography>
                                    {/* <Typography variant="body1" align="center">
        Price: {subscription.price}
 
      </Typography> */}
                                  </Paper>
                                ) : (
                                  <Typography variant="body1" align="center">
                                    No subscription found.
                                  </Typography>
                                )}
                              </TabPanel>

                              <TabPanel value="2">
                                <Grid
                                  container
                                  spacing={2}
                                  wrap="wrap"
                                  justifyContent="space-between"
                                >
                                  <Grid item>
                                    <Paper
                                      sx={{
                                        padding: 2,
                                        width: 180,
                                        border: "1px solid #ccc",
                                        boxShadow: 3,
                                        "&:hover": {
                                          transform: "scale(1.05)",
                                          transition: "transform 0.2s",
                                          zIndex: 1,
                                        },
                                        cursor: "pointer",
                                        backgroundColor: showPromotionalCredits
                                          ? "#0baae4"
                                          : "inherit",
                                      }}
                                      onClick={handlePromotionalCredits}
                                    >
                                      <Box textAlign="center">
                                        <Typography variant="subtitle1">
                                          Promotional Credits
                                        </Typography>
                                        <Typography variant="h6">
                                          {voucherCount}
                                        </Typography>
                                      </Box>
                                    </Paper>
                                  </Grid>
                                  <Grid item>
                                    <Paper
                                      sx={{
                                        padding: 2,
                                        width: 180,
                                        border: "1px solid #ccc",
                                        boxShadow: 3,
                                        "&:hover": {
                                          transform: "scale(1.05)",
                                          transition: "transform 0.2s",
                                          zIndex: 1,
                                        },
                                        cursor: "pointer",
                                        backgroundColor: showUsedCredits
                                          ? "#0baae4"
                                          : "inherit",
                                      }}
                                      onClick={handleUsedCredits}
                                    >
                                      <Box textAlign="center">
                                        <Typography variant="subtitle1">
                                          Used Credits
                                        </Typography>
                                        <Typography variant="h6">
                                          0/{voucherCount}
                                        </Typography>
                                      </Box>
                                    </Paper>
                                  </Grid>
                                  <Grid item>
                                    <Paper
                                      sx={{
                                        padding: 2,
                                        width: 180,
                                        border: "1px solid #ccc",
                                        boxShadow: 3,
                                        "&:hover": {
                                          transform: "scale(1.05)",
                                          transition: "transform 0.2s",
                                          zIndex: 1,
                                        },
                                        cursor: "pointer",
                                        backgroundColor: showBalancedCredits
                                          ? "#0baae4"
                                          : "inherit",
                                      }}
                                      onClick={handleBalancedCredits}
                                    >
                                      <Box textAlign="center">
                                        <Typography variant="subtitle1">
                                          Balanced Credits
                                        </Typography>
                                        <Typography variant="h6">
                                          0/{voucherCount}
                                        </Typography>
                                      </Box>
                                    </Paper>
                                  </Grid>
                                  <Grid item>
                                    <Paper
                                      sx={{
                                        padding: 2,
                                        width: 180,
                                        border: "1px solid #ccc",
                                        boxShadow: 3,
                                        "&:hover": {
                                          transform: "scale(1.05)",
                                          transition: "transform 0.2s",
                                          zIndex: 1,
                                        },
                                        cursor: "pointer",
                                      }}
                                    >
                                      <Box textAlign="center">
                                        <Typography variant="subtitle1">
                                          Expired Credits
                                        </Typography>
                                        <Typography variant="h6">0</Typography>
                                      </Box>
                                    </Paper>
                                  </Grid>
                                </Grid>
                                {showPromotionalCredits && (
                                  <TableContainer open={showPromotionalCredits}>
                                    <Table>
                                      <TableHead>
                                        <TableRow>
                                          <TableCell>Voucher Name</TableCell>
                                          <TableCell>From Date</TableCell>
                                          <TableCell>End Date</TableCell>
                                          <TableCell>Limit</TableCell>
                                          <TableCell>Status</TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {voucher.map((voucher) => (
                                          <TableRow key={voucher.voucher_id}>
                                            <TableCell>
                                              {voucher.name}
                                            </TableCell>
                                            <TableCell>
                                              {voucher.from}
                                            </TableCell>
                                            <TableCell>{voucher.end}</TableCell>
                                            <TableCell>
                                              {voucher.limit}
                                            </TableCell>
                                            <TableCell>
                                              {isVoucherActive(
                                                voucher.from,
                                                voucher.end
                                              )
                                                ? "Active"
                                                : "Inactive"}
                                            </TableCell>
                                          </TableRow>
                                        ))}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                )}

                                {showBalancedCredits && (
                                  <Box sx={{ marginTop: 3 }}>
                                    <Select
                                      value={selectedVoucher}
                                      onChange={handleVoucherChange}
                                      sx={{ width: 250 }}
                                    >
                                      {voucher.map((voucher) => (
                                        <MenuItem
                                          key={voucher.vocher_id}
                                          value={voucher.vocher_id}
                                        >
                                          {voucher.name}
                                        </MenuItem>
                                      ))}
                                    </Select>

                                    {selectedVoucherData && (
                                      <Box sx={{ marginTop: 2 }}>
                                        <Box
                                          sx={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: 2,
                                          }}
                                        >
                                          {selectedVoucherData.voucherCodes.map(
                                            (code, index) => (
                                              <Paper
                                                key={index}
                                                sx={{
                                                  padding: 2,
                                                  border: "1px solid #ccc",
                                                  boxShadow: 3,
                                                  width: 250,
                                                  display: "flex",
                                                  flexDirection: "column",
                                                  justifyContent:
                                                    "space-between",
                                                  alignItems: "start",
                                                }}
                                              >
                                                <Box sx={{ marginBottom: 1 }}>
                                                  <Typography variant="body1">
                                                    From:{" "}
                                                    {selectedVoucherData.from}
                                                  </Typography>
                                                  <Typography variant="body1">
                                                    End:{" "}
                                                    {selectedVoucherData.end}
                                                  </Typography>
                                                  <Typography variant="body1">
                                                    Code: {code}
                                                  </Typography>
                                                </Box>
                                                <Box
                                                  sx={{
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-between",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() =>
                                                      handleOpen(code)
                                                    }
                                                  >
                                                    Assign
                                                  </Button>
                                                  <IconButton aria-label="share">
                                                    <ShareIcon />
                                                  </IconButton>
                                                </Box>
                                              </Paper>
                                            )
                                          )}
                                        </Box>
                                      </Box>
                                    )}
                                  </Box>
                                )}
                                <Modal open={opens} onClose={handleCloses}>
                                  <Box
                                    sx={{
                                      position: "absolute",
                                      top: "50%",
                                      left: "50%",
                                      transform: "translate(-50%, -50%)",
                                      width: 400,
                                      bgcolor: "background.paper",
                                      border: "2px solid #000",
                                      boxShadow: 24,
                                      p: 4,
                                    }}
                                  >
                                    <Typography variant="h6" component="h2">
                                      Assign Code
                                    </Typography>
                                    <Typography sx={{ mt: 2 }}>
                                      Code: {selectedCode}
                                    </Typography>
                                    <Box sx={{ mt: 2 }}>
                                      <InputLabel id="user-select-label">
                                        Select User
                                      </InputLabel>
                                      <Select
                                        labelId="user-select-label"
                                        value={selectedUser}
                                        onChange={(e) =>
                                          setSelectedUser(e.target.value)
                                        }
                                        fullWidth
                                      >
                                        {customers.map((customer) => (
                                          <MenuItem
                                            key={customer._id}
                                            value={customer._id}
                                          >
                                            {customer.name}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </Box>
                                    <Box sx={{ mt: 2, textAlign: "right" }}>
                                      <Button
                                        onClick={handleCloses}
                                        sx={{ mr: 1 }}
                                      >
                                        Cancel
                                      </Button>
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleAssign}
                                      >
                                        Assign
                                      </Button>
                                    </Box>
                                  </Box>
                                </Modal>

                                {showUsedCredits && (
                                  <Box sx={{marginTop:3}}>
                                    <Select value={selectedVoucher}
                                    onChange={handleVoucherChange}
                                    sx={{width:250}}>
                                      {voucher.map((voucher) => (
                                        <MenuItem
                                          key={voucher.vocher_id}
                                          value={voucher.vocher_id}
                                        >
                                          {voucher.name}
                                        </MenuItem>
                                      ))}

                                    </Select>
                                  </Box>
                                )}
                                
                              </TabPanel>

                              <TabPanel value="3">
                                <Button
                                  variant="contained"
                                  sx={{
                                    backgroundColor: "#0baae5",
                                    color: "#fff",
                                    marginBottom: "20px",
                                    textTransform: "none",
                                    "&:hover": {
                                      backgroundColor: "#0baae5",
                                    },
                                  }}
                                  onClick={handleShowModalAdd}
                                >
                                  + Add New Address
                                </Button>
                                <Modal
                                  open={showModalAdd}
                                  onClose={handleCloseModalAdd}
                                  closeAfterTransition
                                  BackdropProps={{
                                    style: {
                                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                                    },
                                  }}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                  disableBackdropClick
                                >
                                  <Fade in={showModalAdd}>
                                    <Box
                                      sx={{
                                        bgcolor: "background.paper",
                                        boxShadow: 1,
                                        p: 4,
                                        borderRadius: 2,
                                        width: "60%",
                                        marginBottom: "20px",
                                      }}
                                    >
                                      <h2>
                                        {addressId
                                          ? "Edit Address"
                                          : "Add Address"}
                                      </h2>
                                      <form
                                        onSubmit={
                                          addressId
                                            ? handleUpdateAddress
                                            : handleSubmitAddress
                                        }
                                      >
                                        <Grid container spacing={2}>
                                          <Grid item xs={6}>
                                            <TextField
                                              label="Address (Building No/floor)"
                                              fullWidth
                                              name="Address"
                                              value={newaddress.Address}
                                              onChange={handleChangeAddress}
                                              variant="outlined"
                                              margin="normal"
                                            />
                                            <TextField
                                              label="Locality"
                                              fullWidth
                                              name="locality"
                                              value={newaddress.locality}
                                              onChange={handleChangeAddress}
                                              variant="outlined"
                                              margin="normal"
                                            />
                                            <TextField
                                              label="City"
                                              fullWidth
                                              name="city"
                                              value={newaddress.city}
                                              onChange={handleChangeAddress}
                                              variant="outlined"
                                              margin="normal"
                                            />
                                            <TextField
                                              label="Country"
                                              fullWidth
                                              name="country"
                                              value={newaddress.country}
                                              onChange={handleChangeAddress}
                                              variant="outlined"
                                              margin="normal"
                                            />
                                          </Grid>
                                          <Grid item xs={6}>
                                            <TextField
                                              label="Address (Area/Street)"
                                              fullWidth
                                              name="area"
                                              value={newaddress.area}
                                              onChange={handleChangeAddress}
                                              variant="outlined"
                                              margin="normal"
                                            />
                                            <TextField
                                              label="Landmark"
                                              fullWidth
                                              name="landmark"
                                              value={newaddress.landmark}
                                              onChange={handleChangeAddress}
                                              variant="outlined"
                                              margin="normal"
                                            />
                                            <TextField
                                              label="State"
                                              fullWidth
                                              name="state"
                                              value={newaddress.state}
                                              onChange={handleChangeAddress}
                                              variant="outlined"
                                              margin="normal"
                                            />
                                            <TextField
                                              label="PIN Code"
                                              fullWidth
                                              name="pincode"
                                              value={newaddress.pincode}
                                              onChange={handleChangeAddress}
                                              variant="outlined"
                                              margin="normal"
                                            />
                                          </Grid>
                                          <Grid item xs={6}>
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  checked={isPrimaryAddress}
                                                  onChange={
                                                    handleAddCheckboxChange
                                                  }
                                                  name="isPrimaryAddress"
                                                  color="primary"
                                                />
                                              }
                                              label="Is Primary Address"
                                            />
                                          </Grid>
                                        </Grid>
                                        <Grid
                                          container
                                          justifyContent="flex-end"
                                          style={{
                                            marginTop: "40px",
                                            marginBottom: "0px",
                                          }}
                                        >
                                          <Button
                                            variant="outlined"
                                            color="error"
                                            style={{ marginRight: "10px" }}
                                            onClick={handleCloseModalAdd}
                                          >
                                            Close
                                          </Button>
                                          <Button
                                            type="submit"
                                            variant="contained"
                                            color="primary"
                                            style={{
                                              backgroundColor: "#0baae5",
                                            }}
                                          >
                                            {addressId ? "Update" : "Submit"}
                                          </Button>
                                        </Grid>
                                      </form>
                                    </Box>
                                  </Fade>
                                </Modal>

                                <Dialog open={showAddPrimaryConfirmation}>
                                  <DialogTitle>
                                    Confirm Primary Address
                                  </DialogTitle>
                                  <DialogContent>
                                    <DialogContentText>
                                      Do you want to set this Address as the
                                      Primary Address?
                                    </DialogContentText>
                                  </DialogContent>
                                  <DialogActions>
                                    <Button
                                      onClick={() =>
                                        handleAddPrimaryConfirmation(false)
                                      }
                                      color="primary"
                                    >
                                      No
                                    </Button>
                                    <Button
                                      onClick={() =>
                                        handleAddPrimaryConfirmation(true)
                                      }
                                      color="primary"
                                      autoFocus
                                    >
                                      Yes
                                    </Button>
                                  </DialogActions>
                                </Dialog>

                                {sortedAddresses.map((address, index) => (
                                  <Paper
                                    key={index}
                                    sx={{
                                      padding: 2,
                                      marginBottom: 2,
                                      position: "relative",
                                    }}
                                  >
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: 8,
                                        right: 8,
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {address.isPrimaryAddress && (
                                        <Badge
                                          badgeContent="Primary"
                                          color="primary"
                                          sx={{
                                            fontSize: "0.75rem",
                                            marginRight: "50px",
                                          }}
                                        />
                                      )}
                                      <AddressAction row={address} />
                                    </div>
                                    <Typography variant="body1" align="left">
                                      <div>{address.Address}</div>
                                      <div>{address.area}</div>
                                      <div>{address.locality}</div>
                                      <div>
                                        {address.city}, {address.country},{" "}
                                        {address.landmark}, {address.state},{" "}
                                        {address.pincode}
                                      </div>
                                    </Typography>
                                  </Paper>
                                ))}
                              </TabPanel>

                              <TabPanel value="4">
                                <TableContainer component={Paper}>
                                  <Table>
                                    <TableHead>
                                      <TableRow>
                                        <TableCell width="100px" align="center">
                                          S.No
                                        </TableCell>
                                        <TableCell width="180px" align="left">
                                          Transaction Title
                                        </TableCell>
                                        <TableCell width="180px" align="left">
                                          Date
                                        </TableCell>
                                        <TableCell width="180px" align="left">
                                          Invoice Value
                                        </TableCell>
                                        <TableCell width="100px" align="center">
                                          Actions
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {transactions.map((row, index) => (
                                        <TableRow key={row.id}>
                                          <TableCell
                                            width="100px"
                                            align="center"
                                          >
                                            {index + 1}
                                          </TableCell>
                                          <TableCell width="180px" align="left">
                                            {row.details}
                                          </TableCell>
                                          <TableCell width="180px" align="left">
                                            {row.date}
                                          </TableCell>
                                          <TableCell width="180px" align="left">
                                            {row.value}
                                          </TableCell>
                                          <TableCell
                                            width="100px"
                                            align="center"
                                          >
                                            <IconButton
                                              component={Link}
                                              to={"/organisation/invoice"}
                                              target="_blank"
                                            >
                                              <FiEye
                                                color="#9368f3"
                                                size="20"
                                              />
                                            </IconButton>
                                            {/* <IconButton
                                              onClick={() =>
                                                handleDownload(row.id)
                                              }
                                            >
                                              <GetAppIcon />
                                            </IconButton> */}
                                          </TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </TabPanel>
                              <Dialog
                                open={open}
                                onClose={handleClose}
                                PaperProps={{
                                  style: {
                                    width: "80%",
                                    maxHeight: "80%",
                                  },
                                }}
                              >
                                <DialogTitle>Invoice Details</DialogTitle>
                                <DialogContent>
                                  <TableContainer>
                                    <Table>
                                      <TableBody>
                                        <TableRow>
                                          <TableCell colSpan={2}>
                                            <Typography
                                              variant="h6"
                                              gutterBottom
                                            >
                                              VELZON
                                            </Typography>
                                            <Typography variant="body2">
                                              California, United States
                                              <br />
                                              90201
                                            </Typography>
                                          </TableCell>
                                        </TableRow>
                                        <TableRow>
                                          <TableCell>
                                            <strong>Invoice No:</strong>
                                          </TableCell>
                                          <TableCell>
                                            {invoice.invoiceNo}
                                          </TableCell>
                                        </TableRow>
                                        <TableRow>
                                          <TableCell>
                                            <strong>Date:</strong>
                                          </TableCell>
                                          <TableCell>{invoice.date}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                          <TableCell>
                                            <strong>Payment Status:</strong>
                                          </TableCell>
                                          <TableCell>
                                            {invoice.paymentStatus}
                                          </TableCell>
                                        </TableRow>
                                        <TableRow>
                                          <TableCell>
                                            <strong>Total Amount:</strong>
                                          </TableCell>
                                          <TableCell>
                                            {invoice.totalAmount}
                                          </TableCell>
                                        </TableRow>
                                        <TableRow>
                                          <TableCell>
                                            <strong>Billing Address:</strong>
                                          </TableCell>
                                          <TableCell>
                                            {invoice.billingAddress.name}
                                            <br />
                                            {invoice.billingAddress.address}
                                            <br />
                                            Phone:{" "}
                                            {invoice.billingAddress.phone}
                                          </TableCell>
                                        </TableRow>
                                        <TableRow>
                                          <TableCell>
                                            <strong>Shipping Address:</strong>
                                          </TableCell>
                                          <TableCell>
                                            {invoice.shippingAddress.name}
                                            <br />
                                            {invoice.shippingAddress.address}
                                            <br />
                                            Phone:{" "}
                                            {invoice.shippingAddress.phone}
                                          </TableCell>
                                        </TableRow>
                                        <TableRow>
                                          <TableCell colSpan={2}>
                                            <Typography variant="body2">
                                              Legal Registration No:{" "}
                                              {invoice.legalRegistrationNo}
                                              <br />
                                              Email: {invoice.email}
                                              <br />
                                              Website: {invoice.website}
                                              <br />
                                              Contact No: {invoice.contactNo}
                                            </Typography>
                                          </TableCell>
                                        </TableRow>
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </DialogContent>
                                <DialogActions>
                                  <Button onClick={handleClose} color="primary">
                                    Close
                                  </Button>
                                </DialogActions>
                              </Dialog>

                              <TabPanel value="5">
                                <Button
                                  variant="contained"
                                  sx={{
                                    backgroundColor: "#0baae5",
                                    color: "#fff",
                                    marginBottom: "20px",
                                    textTransform: "none",
                                    "&:hover": {
                                      backgroundColor: "#0baae5",
                                    },
                                  }}
                                  onClick={handleShowModal}
                                >
                                  + Add Recipient
                                </Button>
                                <Modal
                                  open={showModal}
                                  onClose={handleCloseModal}
                                  closeAfterTransition
                                  BackdropProps={{
                                    style: {
                                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                                    },
                                  }}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                  disableBackdropClick
                                >
                                  <Fade in={showModal}>
                                    <Box
                                      sx={{
                                        bgcolor: "background.paper",
                                        boxShadow: 1,
                                        p: 4,
                                        borderRadius: 2,
                                        width: "60%",
                                        marginBottom: "20px",
                                      }}
                                    >
                                      <h2>
                                        {recipientId
                                          ? "Edit Recipient"
                                          : "Add Recipient"}
                                      </h2>
                                      <form
                                        onSubmit={
                                          recipientId
                                            ? handleUpdate
                                            : handleSubmit
                                        }
                                      >
                                        <Grid
                                          container
                                          spacing={2}
                                          style={{ marginTop: "0px" }}
                                        >
                                          <Grid item xs={12}>
                                            <TextField
                                              fullWidth
                                              label="Email"
                                              variant="outlined"
                                              placeholder="Enter Email"
                                              name="recipientEmail"
                                              value={data.recipientEmail}
                                              onChange={handleChange}
                                              required
                                            />
                                          </Grid>
                                          <Grid item xs={12}>
                                            <TextField
                                              fullWidth
                                              label="Recipient Name"
                                              variant="outlined"
                                              placeholder="Enter Recipient Name"
                                              name="recipientName"
                                              value={data.recipientName}
                                              onChange={handleChange}
                                            />
                                          </Grid>
                                          <Grid item xs={12}>
                                            <TextField
                                              fullWidth
                                              label="Designation"
                                              variant="outlined"
                                              placeholder="Enter Designation"
                                              name="designation"
                                              value={data.designation}
                                              onChange={handleChange}
                                            />
                                          </Grid>
                                          <Grid item xs={12}>
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  checked={isPrimaryEmail}
                                                  onChange={
                                                    handleCheckboxChange
                                                  }
                                                  name="isPrimaryEmail"
                                                  color="primary"
                                                />
                                              }
                                              label="Is Primary Email"
                                            />
                                          </Grid>
                                        </Grid>
                                        <Grid
                                          container
                                          justifyContent="flex-end"
                                          style={{
                                            marginTop: "40px",
                                            marginBottom: "0px",
                                          }}
                                        >
                                          <Button
                                            variant="outlined"
                                            color="error"
                                            style={{ marginRight: "10px" }}
                                            onClick={handleCloseModal}
                                          >
                                            Close
                                          </Button>
                                          <Button
                                            type="submit"
                                            variant="contained"
                                            color="primary"
                                            style={{
                                              backgroundColor: "#0baae5",
                                            }}
                                          >
                                            {recipientId ? "Update" : "Submit"}
                                          </Button>
                                        </Grid>
                                      </form>
                                    </Box>
                                  </Fade>
                                </Modal>

                                <Dialog open={showPrimaryConfirmation}>
                                  <DialogTitle>
                                    Confirm Primary Email
                                  </DialogTitle>
                                  <DialogContent>
                                    <DialogContentText>
                                      Do you want to set this email ID as the
                                      primary email?
                                    </DialogContentText>
                                  </DialogContent>
                                  <DialogActions>
                                    <Button
                                      onClick={() =>
                                        handlePrimaryConfirmationClose(false)
                                      }
                                      color="primary"
                                    >
                                      No
                                    </Button>
                                    <Button
                                      onClick={() =>
                                        handlePrimaryConfirmationClose(true)
                                      }
                                      color="primary"
                                      autoFocus
                                    >
                                      Yes
                                    </Button>
                                  </DialogActions>
                                </Dialog>

                                <TableContainer component={Paper}>
                                  <Table>
                                    <TableHead>
                                      <TableRow>
                                        <TableCell width="80px" align="center">
                                          S.No
                                        </TableCell>
                                        <TableCell width="180px" align="left">
                                          Email
                                        </TableCell>
                                        <TableCell width="180px" align="left">
                                          Recipient Name
                                        </TableCell>
                                        <TableCell width="180px" align="left">
                                          Designation
                                        </TableCell>
                                        <TableCell width="180px" align="left">
                                          Actions
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {sortedRecipients.map(
                                        (recipient, index) => (
                                          <TableRow key={index}>
                                            <TableCell align="center">
                                              <Typography>
                                                {index + 1}
                                              </Typography>
                                            </TableCell>
                                            <TableCell>
                                              {recipient.recipientEmail}
                                              {recipient.isPrimary && (
                                                <Badge
                                                  badgeContent="Primary"
                                                  color="primary"
                                                  sx={{
                                                    marginLeft: 4,
                                                    fontSize: "0.75rem",
                                                  }}
                                                />
                                              )}
                                            </TableCell>
                                            <TableCell>
                                              {recipient.recipientName}
                                            </TableCell>
                                            <TableCell>
                                              {recipient.designation}
                                            </TableCell>
                                            <TableCell>
                                              <Action row={recipient} />
                                            </TableCell>
                                          </TableRow>
                                        )
                                      )}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </TabPanel>

                              <TabPanel value="6">
                                <Paper sx={{ padding: 2 }}>
                                  <Typography
                                    variant="h6"
                                    align="left"
                                    sx={{
                                      borderBottom: 1,
                                      borderColor: "divider",
                                      paddingBottom: "8px",
                                      marginBottom: "16px",
                                    }}
                                  >
                                    PAYMENT METHODS
                                  </Typography>

                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-around",
                                      marginTop: "16px",
                                      marginBottom: "32px",
                                    }}
                                  >
                                    <img
                                      src="/assets/images/payment/mastercard.png"
                                      alt="MasterCard"
                                      style={{ width: "50px" }}
                                    />
                                    <img
                                      src="/assets/images/payment/visa.png"
                                      alt="Visa"
                                      style={{ width: "50px" }}
                                    />

                                    <img
                                      src="/assets/images/payment/paypal.png"
                                      alt="PayPal"
                                      style={{ width: "50px" }}
                                    />
                                  </Box>
                                  <Button
                                    variant="contained"
                                    sx={{
                                      width: "100%",
                                      backgroundColor: "#009cde",
                                      color: "#fff",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    PayPal
                                  </Button>
                                  <Button
                                    variant="contained"
                                    sx={{
                                      width: "100%",
                                      backgroundColor: "#333",
                                      color: "#fff",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <i
                                      className="fa fa-credit-card"
                                      style={{ marginRight: "8px" }}
                                    ></i>
                                    Debit or Credit Card
                                  </Button>
                                  <Typography
                                    sx={{
                                      marginTop: "10px",
                                      fontSize: "12px",
                                      color: "#aaa",
                                      textAlign: "center",
                                    }}
                                  >
                                    Powered by PayPal
                                  </Typography>
                                </Paper>
                              </TabPanel>
                            </TabContext>
                          </Box>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Subscription;
